<template>
  <v-container fluid fill-height>
    <v-row>
      <v-spacer v-if="$vuetify.display.lgAndUp"/>
      <v-col
          md="12"
          lg="10"
      >
        <v-card
            color="grey-lighten-4"
            class="rounded pa-6 elevation-0"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                  label="Client name"
                  variant="outlined"
                  clearable
                  @update:model-value="$emit('update:clientName', $event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                md="6"
            >
              <v-select
                  :items="filterOptions.states"
                  label="Select status"
                  bg-color="grey-lighten-5"
                  @update:model-value="$emit('update:state', $event)"
              />
            </v-col>
            <v-col
                cols="12"
                md="6"
            >
              <v-checkbox
                  :model-value="checked"
                  label="Show only own orders"
                  @update:model-value="$emit('update:showOnlyOwn', $event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                md="12"
            >
              <v-row>
                <v-col>
                  <v-text-field
                      label="Created from"
                      variant="outlined"
                      type="date"
                      clearable
                      @update:model-value="$emit('update:createdAtFrom', $event)"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                      label="to"
                      variant="outlined"
                      type="date"
                      clearable
                      @update:model-value="$emit('update:createdAtTo', $event)"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                md="6"
            >
              <v-select
                  :items="filterOptions.manufacturers"
                  :loading="filterLoadingStates.manufacturers"
                  label="Select manufacturer"
                  bg-color="grey-lighten-5"
                  @update:model-value="$emit('update:manufacturer', $event)"
              />
            </v-col>
            <v-col
                cols="12"
                md="6"
            >
              <v-select
                  :items="filterOptions.models"
                  :loading="filterLoadingStates.models"
                  :model-value="model"
                  label="Select model"
                  bg-color="grey-lighten-5"
                  @update:model-value="$emit('update:model', $event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                md="6"
            >
              <v-select
                  :items="filterOptions.generations"
                  :loading="filterLoadingStates.generations"
                  :model-value="generation"
                  label="Select generation"
                  bg-color="grey-lighten-5"
                  @update:model-value="$emit('update:generation', $event)"
              />
            </v-col>
            <v-col
                cols="12"
                md="6"
            >
              <v-select
                  :items="filterOptions.wheelDrives"
                  :loading="filterLoadingStates.specifications"
                  :model-value="wheelDrive"
                  label="Select wheel drive"
                  bg-color="grey-lighten-5"
                  @update:model-value="$emit('update:wheelDrive', $event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
                cols="12"
            >
              <v-select
                  :items="filterOptions.filteredSpecifications"
                  :loading="filterLoadingStates.specifications"
                  :model-value="specification"
                  label="Select specification"
                  bg-color="grey-lighten-5"
                  @update:model-value="$emit('update:specification', $event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                md="6"
            >
              <v-row>
                <v-col>
                  <v-text-field
                      label="Price from, $"
                      variant="outlined"
                      clearable
                      @update:model-value="$emit('update:priceFrom', $event)"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                      label="to"
                      variant="outlined"
                      clearable
                      @update:model-value="$emit('update:priceTo', $event)"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col
                cols="12"
                md="6"
            >
              <v-row>
                <v-col
                    cols="12"
                    md="6"
                >
                  <v-select
                      :items="filterOptions.fuels"
                      :loading="filterLoadingStates.fuels"
                      label="Select fuel"
                      bg-color="grey-lighten-5"
                      @update:model-value="$emit('update:fuel', $event)"
                  />
                </v-col>
                <v-col
                    cols="12"
                    md="6"
                >
                  <v-select
                      :items="filterOptions.transmissions"
                      :loading="filterLoadingStates.transmissions"
                      label="Select transmission"
                      bg-color="grey-lighten-5"
                      @update:model-value="$emit('update:transmission', $event)"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                md="6"
            >
              <v-row>
                <v-col>
                  <v-select
                      :clearable="true"
                      :items="yearOptions"
                      label="Year from"
                      bg-color="grey-lighten-5"
                      @update:model-value="$emit('update:yearFrom', $event)"
                  />
                </v-col>
                <v-col>
                  <v-select
                      :clearable="true"
                      :items="yearOptions"
                      label="to"
                      bg-color="grey-lighten-5"
                      @update:model-value="$emit('update:yearTo', $event)"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col
                cols="12"
                md="6"
            >
              <v-row>
                <v-col
                    cols="12"
                    md="6"
                >
                  <v-text-field
                      :clearable="true"
                      label="Engine from"
                      variant="outlined"
                      @update:model-value="$emit('update:engineFrom', $event)"
                  />
                </v-col>
                <v-col
                    cols="12"
                    md="6"
                >
                  <v-text-field
                      :clearable="true"
                      label="Engine to"
                      variant="outlined"
                      @update:model-value="$emit('update:engineTo', $event)"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-spacer v-if="$vuetify.display.lgAndUp"/>
    </v-row>
  </v-container>
</template>

<script>

export default{
  name: "CarRequestFilter",
  emits: ['update:clientName', 'update:state', 'update:showOnlyOwn', 'update:createdAtFrom', 'update:createdAtTo', 'update:manufacturer', 'update:model', 'update:generation', 'update:wheelDrive', 'update:specification', 'update:fuel', 'update:transmission', 'update:priceFrom', 'update:priceTo', 'update:yearFrom', 'update:yearTo', 'update:engineFrom', 'update:engineTo'],
  props: {
    //requestsFilters
    clientName: String,
    state: String,
    showOnlyOwn: Boolean,
    createdAtFrom: String,
    createdAtTo: String,
    //carsFilters
    manufacturer: String,
    model: String,
    generation: String,
    wheelDrive: String,
    specification: String,
    fuel: String,
    transmission: String,
    engineFrom: Number,
    engineTo: Number,
    priceFrom: String,
    priceTo: String,
    yearFrom: String,
    yearTo: String,
    yearOptions: Array,
    filterOptions: {
      states: {
        default: [],
        type: Array
      },
      manufacturers: {
        default: [],
        type: Array
      },
      models: {
        default: [],
        type: Array
      },
      generations: {
        default: [],
        type: Array
      },
      wheelDrives: {
        default: [],
        type: Array
      },
      specifications: {
        default: [],
        type: Array
      },
      fuels: {
        default: [],
        type: Array
      },
      transmissions: {
        default: [],
        type: Array
      },
    },
    filterLoadingStates: {
      manufacturers: {
        default: true,
        type: Boolean
      },
      models: {
        default: false,
        type: Boolean
      },
      fuels: {
        default: true,
        type: Boolean
      },
      transmissions: {
        default: true,
        type: Boolean
      },
    }
  },
  computed: {
    checked() {
      return this.showOnlyOwn
    }
  }
}
</script>

<style scoped>

</style>